import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import PasswordChangeModal from '../PasswordChangeModal';
import supabase from '../../../supabase-client';

const AdminDownbar = () => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { name: 'Principal', path: '/admin-dashboard-screen', icon: 'LayoutDashboard', badge: null },
    { name: 'Autores', path: '/admin-authors', icon: 'Feather', badge: null },
    { name: 'Categorías', path: '/admin-categories', icon: 'Layers', badge: null },
    { name: 'Catálogo', path: '/admin-catalog-management-screen', icon: 'BookOpen', badge: null },
    { name: 'Estadísticas', path: '/admin-reports', icon: 'BarChart3', badge: null }
  ];

  const handleLogout = () => {
    // Limpiar localStorage
    localStorage.removeItem('userType');
    localStorage.removeItem('userName');
    localStorage.removeItem('adminId');
    localStorage.removeItem('adminEmail');
    
    navigate('/login-screen');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-primary border-t border-border shadow-md lg:hidden">
      <div className="flex justify-around items-center py-2">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.name}
              to={item.path}
              className={`relative flex flex-col items-center justify-center text-xs transition-all duration-200 ${
                isActive
                  ? 'text-accent'
                  : 'text-primary-foreground hover:text-accent'
              }`}
              title={item.name}
            >
              <Icon name={item.icon} size={22} />
              {item.badge && (
                <span className="absolute top-0 right-2 bg-accent text-accent-foreground text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                  {item.badge > 9 ? '9+' : item.badge}
                </span>
              )}
            </Link>
          );
        })}
      </div>

      {/* Ayuda, Cambiar Contraseña y Cerrar Sesión */}
      <div className="border-t border-white/10 px-2 py-2 flex justify-around items-center text-xs text-primary-foreground">
        <Link
          to="/admin-help-screen"
          className="flex flex-col items-center gap-1 hover:text-accent transition-smooth min-w-0"
        >
          <Icon name="HelpCircle" size={18} />
          <span className="text-center">Ayuda</span>
        </Link>
        <button
          onClick={() => setIsPasswordModalOpen(true)}
          className="flex flex-col items-center gap-1 hover:text-accent transition-smooth min-w-0"
        >
          <Icon name="Key" size={18} />
          <span className="text-center">Contraseña</span>
        </button>
        <button
          onClick={handleLogout}
          className="flex flex-col items-center gap-1 hover:text-accent transition-smooth min-w-0"
        >
          <Icon name="LogOut" size={18} />
          <span className="text-center">Cerrar Sesión</span>
        </button>
      </div>

      {/* Password Change Modal */}
      <PasswordChangeModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
      />
    </nav>
  );
};

export default AdminDownbar;
